// extracted by mini-css-extract-plugin
module.exports = {"SubscribeFooter":"SubscribeFooter-SubscribeFooter-3w50H9","SubscribeFooter_fourthree":"SubscribeFooter-SubscribeFooter_fourthree-24gjy3"};